<template>
  <select
    class="form-control Pointer"
    :class="isRequired ? 'required' : ''"
    :disabled="disabled"
    @change="changeSelect"
    v-model="selectedValue"
    v-if="render"
  >
    <option
      v-if="defaultItemId == null || defaultItemId == 0"
      disabled
      selected
      value
    >
      گزینه مد نظر را انتخاب نمایید
    </option>

    <option v-for="item in options" :key="item.id" :value="item.id">
      {{ item.name }}
    </option>
  </select>
</template>

<script>
export default {
  data() {
    return {
      options: null,
      selectedValue: null,
      render: true,
      defaultItem: null,
    };
  },

  props: {
    isRequired: {
      type: Boolean,
      default: false,
    },

    grp: Number,

    disabled: {
      type: Boolean,
      default: false,
    },

    defaultItemId: {
      type: Number,
      default: null,
    },

    defaultItemText: {
      type: String,
      default: null,
    },

    readFromAction: {
      type: String,
      default: null,
    },
  },

  mounted() {
    this.getCombo();
  },

  methods: {
    changeSelect() {
      let value = this.options.find((x) => x.id == this.selectedValue);

      this.$emit("result", value);
    },

    setDefaultItem() {
      // Priority goes to defaultItemId
      if (this.defaultItemId != null && this.defaultItemId != 0) {
        this.selectedValue = this.defaultItemId;
        return;
      }

      // If defaultItemText exists, find the item by name
      if (this.defaultItemText != null && this.defaultItemText !== "") {
        let item = this.options.find((x) => x.name === this.defaultItemText);

        if (item) {
          this.selectedValue = item.id;
          this.$emit("result", item);
        }
      }
    },

    getCombo() {
      let action =
        this.readFromAction == null
          ? "ComboGrp/" + this.grp
          : this.readFromAction;

      this.$PostData_new(action, "get").then((res) => {
        this.options = res;

        // Set default value after options are loaded
        this.setDefaultItem();

        this.render = false;

        this.$nextTick(() => {
          this.render = true;
        });
      });
    },
  },

  watch: {
    defaultItemId(newValue) {
      if (newValue != null && newValue != 0) {
        this.selectedValue = newValue;
      }
    },

    defaultItemText(newValue) {
      if (newValue != null && newValue !== "" && this.options) {
        let item = this.options.find((x) => x.name === newValue);

        if (item) {
          this.selectedValue = item.id;
        }
      }
    },
  },
};
</script>
